<template lang="pug">
#modal-confirmar-excluir
    el-dialog(
        width='450px',
        title='Excluir',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-p Deseja realmente excluir Nota de Pesagem {{numeroOrdemCorte}}?
        br
        el-p Essa ação não poderá ser desfeita.

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='excluir'
            ) Confirmar

</template>

<script>
import RastreabilidadeNotaDePesagemService from '@/services/RastreabilidadeNotaDePesagemService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalConfirmarExcluir',
    components: {
        BaseButton
    },
    emits: ['atualizarDados'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        dados: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroOrdemCorte: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dados) {
                this.id = this.dados.id;
                this.numeroOrdemCorte = this.dados.numeroOrdemCorte;
            }
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        async excluir() {
            try {
                await RastreabilidadeNotaDePesagemService.excluirNotaDePesagem({
                    id: this.dados.id
                });

                this.fechar();
                this.$emit('atualizarDados');

                this.$notify.success({
                    message: 'Nota de Pesagem excluida com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
